var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.unInterruptedView
    ? _c(
        "header",
        { staticClass: "is-fixed-top" },
        [
          _vm.showSpinnerRequestCount > 0
            ? _c(_vm.spinner, {
                tag: "component",
                attrs: { message: _vm.spinnerMessage },
              })
            : _vm._e(),
          _vm.$userInfo
            ? _c("nav", { staticClass: "navbar" }, [
                _c("div", { staticClass: "navbar-brand" }, [
                  _c(
                    "a",
                    {
                      staticClass: "navbar-item fq-logo py-0 pr-1",
                      on: {
                        click: function ($event) {
                          return _vm.gotoRoute(_vm.rootUrl)
                        },
                      },
                    },
                    [
                      _c("img", {
                        staticStyle: { "max-height": "1.875rem" },
                        attrs: {
                          src: _vm.logoImgPath,
                          alt: "",
                          width: "185",
                          height: "30",
                          title: "Home",
                        },
                      }),
                    ]
                  ),
                  _vm.$userInfo.isSupportUser
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "navbar-item is-hidden-desktop tooltip is-tooltip-right",
                          attrs: {
                            href: _vm.pollingLogUrl,
                            title: "Polling Logs",
                            "data-tooltip": "Polling Logs",
                          },
                        },
                        [_vm._m(0)]
                      )
                    : _vm._e(),
                  _vm.$userInfo.isSupportUser
                    ? _c(
                        "a",
                        {
                          staticClass:
                            "navbar-item is-hidden-desktop tooltip is-tooltip-right",
                          attrs: {
                            title: "View Errors",
                            "data-tooltip": "View Errors",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.gotoRoute(_vm.errorLogUrl)
                            },
                          },
                        },
                        [_vm._m(1)]
                      )
                    : _vm._e(),
                  _c(
                    "a",
                    {
                      staticClass:
                        "navbar-item is-hidden-desktop tooltip is-tooltip-right",
                      attrs: { title: "Sign Out", "data-tooltip": "Sign Out" },
                      on: { click: _vm.signOut },
                    },
                    [_vm._m(2)]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "navbar-burger burger",
                      attrs: { "data-target": "main-nav-menu" },
                      on: {
                        click: function ($event) {
                          return _vm.toogleBurgerMenu()
                        },
                      },
                    },
                    [_c("span"), _c("span"), _c("span")]
                  ),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "navbar-menu",
                    class: { "is-active": _vm.burgerMenuActive },
                    attrs: { id: "main-nav-menu" },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "navbar-start" },
                      _vm._l(_vm.finalNav, function (i) {
                        return _c(
                          "div",
                          {
                            key: i.name,
                            staticClass:
                              "navbar-item has-dropdown is-hoverable",
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "navbar-link",
                                on: {
                                  click: function ($event) {
                                    return _vm.go(i)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(i.name) + " ")]
                            ),
                            _c(
                              "div",
                              { staticClass: "navbar-dropdown is-boxed" },
                              _vm._l(i.items, function (i2, idx2) {
                                return _c(
                                  "div",
                                  { key: i2.name },
                                  [
                                    i2.items.length > 0 &&
                                    i.items[idx2 - 1] &&
                                    i.items[idx2 - 1].items.length == 0
                                      ? _c("hr", {
                                          staticClass: "navbar-divider",
                                        })
                                      : _vm._e(),
                                    i2.items.length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "submenu-title" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "title is-6 has-text-primary",
                                              },
                                              [_vm._v(_vm._s(i2.name))]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    i2.items.length == 0
                                      ? _c(
                                          "a",
                                          {
                                            staticClass: "navbar-item",
                                            class: {
                                              "is-active":
                                                i2.code ===
                                                _vm.selectedMenuCode,
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.go(i2, $event)
                                              },
                                              mouseup: function ($event) {
                                                if (
                                                  "button" in $event &&
                                                  $event.button !== 1
                                                )
                                                  return null
                                                return _vm.goNewTab(i2)
                                              },
                                            },
                                          },
                                          [_vm._v(" " + _vm._s(i2.name) + " ")]
                                        )
                                      : _vm._l(i2.items, function (i3) {
                                          return _c(
                                            "a",
                                            {
                                              key: i3.name,
                                              staticClass: "navbar-item",
                                              class: {
                                                "is-active":
                                                  i3.code ===
                                                  _vm.selectedMenuCode,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.go(i3, $event)
                                                },
                                                mouseup: function ($event) {
                                                  if (
                                                    "button" in $event &&
                                                    $event.button !== 1
                                                  )
                                                    return null
                                                  return _vm.goNewTab(i3)
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " + _vm._s(i3.name) + " "
                                              ),
                                            ]
                                          )
                                        }),
                                    i2.items.length > 0
                                      ? _c("hr", {
                                          staticClass: "navbar-divider",
                                        })
                                      : _vm._e(),
                                  ],
                                  2
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                    _vm.isGlobalSearchEnabled
                      ? _c(
                          "div",
                          { staticClass: "navbar-item" },
                          [
                            _c("global-search", {
                              attrs: {
                                "scoped-api-key": _vm.scopedSearchApiKey,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("div", { staticClass: "navbar-end" }, [
                      _vm.$userInfo.isSystemAdministrator &&
                      !_vm.$userInfo.isSupportUser
                        ? _c("div", { staticClass: "navbar-item" }, [
                            _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.redirectToV1Url,
                                  target: "_blank",
                                },
                              },
                              [_vm._v(" Redirect to V1")]
                            ),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "navbar-item" }, [
                        _c(
                          "div",
                          {
                            staticClass: "dropdown is-hoverable theme-dropdown",
                          },
                          [
                            _vm._m(3),
                            _c("div", { staticClass: "dropdown-menu" }, [
                              _c("div", { staticClass: "dropdown-content" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item is-flex is-align-items-center",
                                    class: {
                                      "is-active":
                                        _vm.$theme.displayName ===
                                        _vm.themes.light,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectTheme(_vm.themes.light)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "msr msr-24px has-text-warning mr-2",
                                      },
                                      [_vm._v(" light_mode ")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "is-capitalized" },
                                      [_vm._v(_vm._s(_vm.themes.light))]
                                    ),
                                  ]
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item is-flex is-align-items-center",
                                    class: {
                                      "is-active":
                                        _vm.$theme.displayName ===
                                        _vm.themes.dark,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectTheme(_vm.themes.dark)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "msr msr-24px has-text-primary mr-2",
                                      },
                                      [_vm._v(" dark_mode ")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "is-capitalized" },
                                      [_vm._v(_vm._s(_vm.themes.dark))]
                                    ),
                                  ]
                                ),
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "dropdown-item is-flex is-align-items-center",
                                    class: {
                                      "is-active":
                                        _vm.$theme.displayName ===
                                        _vm.themes.system,
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.selectTheme(
                                          _vm.themes.system
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "msr msr-24px has-text-success mr-2",
                                      },
                                      [_vm._v(" desktop_windows ")]
                                    ),
                                    _c(
                                      "span",
                                      { staticClass: "is-capitalized" },
                                      [_vm._v(_vm._s(_vm.themes.system))]
                                    ),
                                  ]
                                ),
                              ]),
                            ]),
                          ]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "navbar-item py-0" },
                        [_c("vue-clock")],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "navbar-item" },
                        [_c("notification")],
                        1
                      ),
                      false
                        ? _c(
                            "div",
                            { staticClass: "navbar-item" },
                            [_c("agent")],
                            1
                          )
                        : _vm._e(),
                      _c("div", { staticClass: "navbar-item" }, [
                        _c("div", { staticClass: "field is-grouped" }, [
                          _c(
                            "div",
                            {
                              staticClass: "dropdown is-right",
                              class: { "is-active": _vm.companyDropdownActive },
                              on: {
                                mouseleave: function ($event) {
                                  _vm.companyDropdownActive = false
                                },
                              },
                            },
                            [
                              _c("div", { staticClass: "dropdown-trigger" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass: "button company-nav-dropdown",
                                    attrs: {
                                      "aria-haspopup": "true",
                                      "aria-controls": "dropdown-menu",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.toogleDropdown()
                                      },
                                    },
                                  },
                                  [
                                    _c("span", [
                                      _vm._v(_vm._s(_vm.$userInfo.companyName)),
                                    ]),
                                    _vm._m(4),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                {
                                  staticClass: "dropdown-menu",
                                  attrs: { role: "menu" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "dropdown-content" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "dropdown-item dropdown-item-has-icon",
                                        },
                                        [
                                          _vm._m(5),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "dropdown-item-text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$userInfo.displayName
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c("hr", {
                                        staticClass: "dropdown-divider",
                                      }),
                                      _vm.$userInfo.isSupportUser
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "dropdown-item dropdown-item-has-icon",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.gotoRoute(
                                                    _vm.pollingLogUrl
                                                  )
                                                },
                                                mouseup: function ($event) {
                                                  if (
                                                    "button" in $event &&
                                                    $event.button !== 1
                                                  )
                                                    return null
                                                  return _vm.gotoRoute(
                                                    _vm.pollingLogUrl,
                                                    true
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._m(6),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "dropdown-item-text",
                                                },
                                                [_vm._v("Polling Log")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.$userInfo.isSupportUser
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "dropdown-item dropdown-item-has-icon",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.gotoRoute(
                                                    _vm.companyOnboardingUrl
                                                  )
                                                },
                                                mouseup: function ($event) {
                                                  if (
                                                    "button" in $event &&
                                                    $event.button !== 1
                                                  )
                                                    return null
                                                  return _vm.gotoRoute(
                                                    _vm.companyOnboardingUrl,
                                                    true
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _vm._m(7),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "dropdown-item-text",
                                                },
                                                [_vm._v("Company Onboarding")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm.$userInfo.isSupportUser
                                        ? _c(
                                            "a",
                                            {
                                              staticClass:
                                                "dropdown-item dropdown-item-has-icon",
                                              on: {
                                                click: function ($event) {
                                                  _vm.gotoRoute(_vm.errorLogUrl)
                                                  _vm.companyDropdownActive = false
                                                },
                                                mouseup: function ($event) {
                                                  if (
                                                    "button" in $event &&
                                                    $event.button !== 1
                                                  )
                                                    return null
                                                  _vm.gotoRoute(
                                                    _vm.errorLogUrl,
                                                    true
                                                  )
                                                  _vm.companyDropdownActive = false
                                                },
                                              },
                                            },
                                            [
                                              _vm._m(8),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "dropdown-item-text",
                                                },
                                                [_vm._v("View Error")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "dropdown-item dropdown-item-has-icon",
                                          attrs: { href: "#" },
                                          on: { click: _vm.signOut },
                                        },
                                        [
                                          _vm._m(9),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "dropdown-item-text",
                                            },
                                            [_vm._v("Sign Out")]
                                          ),
                                        ]
                                      ),
                                      _c("hr", {
                                        staticClass: "dropdown-divider",
                                      }),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "dropdown-item dropdown-item-has-icon",
                                          attrs: { href: "#" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openAboutModal()
                                            },
                                          },
                                        },
                                        [
                                          _vm._m(10),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "dropdown-item-text",
                                            },
                                            [_vm._v("About")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ])
            : _vm._e(),
          _c("about-modal", {
            attrs: {
              active: _vm.isAboutModalActive,
              "expiry-date": _vm.expiryDate,
            },
            on: {
              "update:active": function ($event) {
                _vm.isAboutModalActive = $event
              },
              close: function ($event) {
                return _vm.closeModal()
              },
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon", staticStyle: { color: "#DC7633" } },
      [_c("i", { staticClass: "mdi mdi-file-document" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon", staticStyle: { color: "#CD6155" } },
      [_c("i", { staticClass: "mdi mdi-alert" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon", staticStyle: { color: "#9B59B6" } },
      [_c("i", { staticClass: "mdi mdi-logout" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dropdown-trigger" }, [
      _c("button", { staticClass: "button is-info is-inverted" }, [
        _c("span", { staticClass: "msr msr-24px has-text-routine mr-2" }, [
          _vm._v(" routine "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small" }, [
      _c("i", { staticClass: "mdi mdi-chevron-down mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon", staticStyle: { color: "#5D6D7E" } },
      [_c("i", { staticClass: "mdi mdi-account mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon", staticStyle: { color: "#DC7633" } },
      [_c("i", { staticClass: "mdi mdi-file-document mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-success" }, [
      _c("i", { staticClass: "mdi mdi-office-building-cog mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-danger" }, [
      _c("i", { staticClass: "mdi mdi-alert mdi-18px" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "span",
      { staticClass: "icon", staticStyle: { color: "#9B59B6" } },
      [_c("i", { staticClass: "mdi mdi-logout mdi-18px" })]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon has-text-primary" }, [
      _c("i", { staticClass: "mdi mdi-information-variant mdi-18px" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }